import React from "react";

import { useEffect } from "react";
import { useState } from "react";
import NavigationBar from "../ReusableComp/NavigationBar";
import { useNavigate } from "react-router-dom";
import { MedicalReviewerFlow } from "../ReusableComp/NavBarLeft";

import { useDispatch, useSelector } from "react-redux";
// import Select from '../../ReusableComp/Select';
import { Card, Col, Container, Row, Stack } from "react-bootstrap";
import {
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  Label,
} from "recharts";
import ToggleButton from "react-toggle-button";
import { getEventFlag } from "../../Redux/actions/actions";

function MedicalReviewerDashboard() {
  const [toggleSAE, setToggleSAE] = useState(false);
  const [mrStudyId,setMrStudyId]=useState("")
  const [seriousAdverseEvents, setSeriousAdverseEvents] = useState({});

  const getMrData = useSelector((state) => state.getMrStudy);
const [adverseEvents, setAdverseEvents] = useState({});
const mrDashboardList = useSelector((state) => state.mrdbcounts);

 const waiting =mrDashboardList?.reviewsCount[0]
 const Inprogress =mrDashboardList?.reviewsCount[1]
 const Completed =mrDashboardList?.reviewsCount[2]
 const Rejected=mrDashboardList?.reviewsCount[3]
 function getDayAbbreviation(dateString) {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const date = new Date(dateString);
  const dayIndex = date.getDay();
  return days[dayIndex];
}

  useEffect(() => {

    if(mrDashboardList && mrDashboardList.length !=0){
      const newData = Object.keys(mrDashboardList?.aesCount).map((date) => ({
        name: getDayAbbreviation(date),
        "Last 7 days reported Adverse Events": mrDashboardList?.aesCount[date],
      }));
      setAdverseEvents(newData);
      const newData1 = Object.keys(mrDashboardList?.saesCount).map((date) => ({
        name: getDayAbbreviation(date),
        "Last 7 days reported Serious Adverse Events": mrDashboardList?.saesCount[date],
      }));
      setSeriousAdverseEvents(newData1);

 
 
    }

 
  }, [mrStudyId, mrDashboardList]);
  
  const generateString = (n) => {
    const array = [];
    for (let i = 1; i <= n; i++) {
      array.push(`D${i}`);
    }
    return array.join(',');
  }; 


  const handleStudyChange = () => {};
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleNavigate =(card, index)=>{
    navigate(card.url);
    let option
    if(card.desc ==="Total Reviews"){
      option = "total_reviews"
    }else if(card.desc==="Total Subjects"){
      option = "all_events"
    }
    card.option = option 
    dispatch(getEventFlag(card))
     
  }

  const dashboardCards = [
    

    {
      count: mrDashboardList?.subjectsCount,
      image: "./images/icons/subjects_white.svg",
      url : "/mrreviewlist",
      desc: "Total Subjects",
      bgcolor: "#8DA2B5",
    },

    {
      count: mrDashboardList?.reviewsCount? mrDashboardList?.reviewsCount[0] + mrDashboardList?.reviewsCount[1] + mrDashboardList?.reviewsCount[2] + mrDashboardList?.reviewsCount[3] :0,
      image: "./images/icons/Group.svg",
      desc: "Total Reviews",
      url : "/mrreviewlist",
      bgcolor: "#FFF8DF",
      textColor: "#000000",
    },
    
  ];

  const data = [
    {
      name: "Jan",
      "Month Wise Subjects Registered": 2400,
      amt: 2400,
    },
    {
      name: "Feb",
      "Month Wise Subjects Registered": 1398,
      amt: 2210,
    },
    {
      name: "Mar",
      "Month Wise Subjects Registered": 9800,
      amt: 2290,
    },
    {
      name: "Apr",
      "Month Wise Subjects Registered": 3908,
      amt: 2000,
    },
    {
      name: "May",
      "Month Wise Subjects Registered": 4800,
      amt: 2181,
    },
    {
      name: "Jun",
      "Month Wise Subjects Registered": 3800,
      amt: 2500,
    },
    {
      name: "Jul",
      "Month Wise Subjects Registered": 4300,
      amt: 2100,
    },
    {
      name: "Aug",
      "Month Wise Subjects Registered": 4800,
      amt: 2181,
    },
    {
      name: "Sep",
      "Month Wise Subjects Registered": 3800,
      amt: 2500,
    },
    {
      name: "Oct",
      "Month Wise Subjects Registered": 4300,
      amt: 2100,
    },
    {
      name: "Nov",
      "Month Wise Subjects Registered": 4800,
      amt: 2181,
    },
    {
      name: "Dec",
      "Month Wise Subjects Registered": 6900,
      amt: 2500,
    },
  ];

  const yValues = data.map((item) => item["Month Wise Subjects Registered"]);
  const minValue = 0;
  const maxValue = Math.max(...yValues);
  const middleValue = (minValue + maxValue) / 2;

  

  const data02 = [
    {
      name: "Completed",
      value: Number(Completed*1000),
      color: "#109E62",
    },
    {
      name: "In Progress",
      value: Number(Inprogress*1000),
      color: "#A6D4C1",
    },
    {
      name: "Waiting list",
      value: Number(waiting*1000),
      color: "#7B7474",
    },
    {
      name: "Rejected list",
      value: Number(Rejected*1000),
      color: "#d14141",
    },
  ];

  const getPath = (x, y, width, height) => {
    const borderRadius = 10;
    const barWidth = width / 1;
    const halfWidth = barWidth / 0.66;

    return `M${x + halfWidth},${y + height - borderRadius}
          L${x + halfWidth},${y + borderRadius}
          Q${x + halfWidth},${y},${x + halfWidth + borderRadius},${y}
          L${x + halfWidth + barWidth - borderRadius},${y}
          Q${x + halfWidth + barWidth},${y},${x + halfWidth + barWidth},${
      y + borderRadius
    }
          L${x + halfWidth + barWidth},${y + height - borderRadius}
          Q${x + halfWidth + barWidth},${y + height},${
      x + halfWidth + barWidth - borderRadius
    },${y + height}
          L${x + halfWidth + borderRadius},${y + height}
          Q${x + halfWidth},${y + height},${x + halfWidth},${
      y + height - borderRadius
    }
          Z`;
  };

  const RoundedBar = (props) => {
    const { fill, x, y, width, height } = props;
    const barWidth = width / 4; // Set the width to one-fourth of the available width

    return (
      <path d={getPath(x, y, barWidth, height)} stroke="none" fill={fill} />
    );
  };

  const onMouseEnter = () => {};


  const totalValue = data02.reduce((sum, entry) => sum + entry.value, 0);
  function getStudieId(id){

    setMrStudyId (id)

 }

  return (
    <div>
      <NavigationBar
        title={"Dashboard"}
        handleFilteredData={handleStudyChange}
        getStudieId={getStudieId}
      />
      {/* <MedicalReviewerFlow /> */}
      <div className="main_body ">
        <Container fluid className="py-4">
          <Stack>
            {/* {listItems && */}
            <ul className="pidblistitems">
              <li><strong>Study Name:</strong> {getMrData?.study_name} </li>

              <li>
              <strong>Study Duration:</strong>{" "}
                <span className="styl">{getMrData?.duration_between_doses} {getMrData?.duration_between_doses_type}</span>
              </li>

              <li><strong>Doses:</strong> {generateString(getMrData?.number_of_doses)}</li>
            </ul>
            {/* } */}
          </Stack>

          <Container fluid className="p-0">
            <Row>
              {dashboardCards.map((card, index) => {
                return (
                  <Col key={index} xs={12} md={4}>
                    <div
                      className="card-container C-pointer"
                      onClick={() => handleNavigate(card, index)}
                      style={{ backgroundColor: card.bgcolor }}
                    >
                      <div
                        className="content"
                        style={{ color: card.textColor }}
                      >
                        <span>{card.count}</span>
                     

                        <img src={card.image} alt="" />
                      </div>
                      <div className="desc" style={{ color: card.textColor }}>
                        {card.desc}
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </Container>

          <Container fluid className="p-0">
            <Row>
              <Col >
                <Card className="pidbcard  shadow  bg-white rounded">
                  <Card.Body className="">
                    <Card.Title className="mb-3 ">
                    Status of Reviews
                    </Card.Title>

                    <PieChart width={530} height={320} >
                      <Pie
                        data={data02}
                        dataKey="value"
                        nameKey="name"
                        cx="50%"
                        cy="50%"
                        innerRadius={60}
                        outerRadius={100}
                        paddingAngle={4}
                      >
                        {data02.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                      </Pie>
                      <Tooltip
                        formatter={(value) =>
                          `${((value / totalValue) * 100).toFixed(2)}%`
                        }
                      />
                      <Legend
                        align="right"
                        verticalAlign="middle"
                        layout="vertical"
                        iconSize={30}
                        formatter={(value, entry) => (
                          <span>
                            <span>{`${entry.payload.name}`}</span>
                            <span style={{ color: "black" }}>
                      {` ${entry.payload.value ? ((entry.payload.value / totalValue) * 100).toFixed(2) :0}%`}</span>
                          </span>
                        )}
                      />
                      <Legend
                        align="right"
                        verticalAlign="middle"
                        layout="vertical"
                        iconSize={30}
                        formatter={(value, entry) =>
                          `${entry.payload.name} ${(
                            (entry.payload.value / totalValue) *
                            100
                          ).toFixed(2)}%`
                        }
                      />
                    </PieChart>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card className="pidbcard  shadow  bg-white rounded">
                  {!toggleSAE ? (
                    <Card.Body>
                      <Card.Title
                        className="mb-3"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        Adverse Events Reported
                        <span style={{ display: "flex" }}>
                          <span>Serious: </span>
                          <span style={{ marginLeft: "10px" }}>
                            <ToggleButton
                              value={toggleSAE}
                              onToggle={() => {
                                setToggleSAE(!toggleSAE);
                              }}
                              inactiveLabel={"No"}
                              activeLabel={"Yes"}
                              colors={{
                                activeThumb: {
                                  base: "rgb(250,250,250)",
                                },
                                active: {
                                  base: "rgb(209, 65, 65)",
                                },
                                inactive: {
                                  base: "rgb((0, 128, 0)",
                                },
                              }}
                            />
                          </span>
                        </span>
                      </Card.Title>
                      <BarChart
                        width={530}
                        barGap={10}
                        height={320}
                        data={adverseEvents}
                        margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
                      >
                        <CartesianGrid strokeDasharray="0" />
                        <XAxis dataKey="name" />
                        <YAxis>
                          <Label
                            dy={-35}
                            value="# of Adverse Events"
                            offset={10}
                            position="insideBottomLeft"
                            angle={-90}
                            fontSize={14}
                          />
                        </YAxis>
                        <Tooltip />
                        <Legend />
                        <Bar
                          dataKey="Last 7 days reported Adverse Events"
                          fill="#EA9E4F"
                          shape={<RoundedBar />}
                          onMouseEnter={onMouseEnter}
                        />
                      </BarChart>
                    </Card.Body>
                  ) : (
                    <Card.Body>
                      <Card.Title
                        className="mb-3"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        Serious Adverse Events Reported
                        <span style={{ display: "flex" }}>
                          <span>Serious: </span>
                          <span style={{ marginLeft: "10px" }}>
                            <ToggleButton
                              value={toggleSAE}
                              onToggle={() => {
                                setToggleSAE(!toggleSAE);
                              }}
                              inactiveLabel={"No"}
                              activeLabel={"Yes"}
                              colors={{
                                activeThumb: {
                                  base: "rgb(250,250,250)",
                                },
                                active: {
                                  base: "rgb(209, 65, 65)",
                                },
                                inactive: {
                                  base: "rgb((0, 128, 0)",
                                },
                              }}
                            />
                          </span>
                        </span>
                      </Card.Title>
                      <BarChart
                        width={530}
                        barGap={10}
                        height={320}
                        data={seriousAdverseEvents}
                        margin={{ top: 5, right: 5, bottom: 5, left: 5 }}
                      >
                        <CartesianGrid strokeDasharray="0" />
                        <XAxis dataKey="name" />
                        <YAxis>
                          <Label
                            dy={-10}
                            value="# of Serious Adverse Events"
                            offset={10}
                            position="insideBottomLeft"
                            angle={-90}
                            fontSize={14}  
                          />
                        </YAxis>
                        <Tooltip />
                        <Legend />
                        <Bar
                          dataKey="Last 7 days reported Serious Adverse Events"
                          fill="#EA9E4F"
                          shape={<RoundedBar />}
                          onMouseEnter={onMouseEnter}
                        />
                      </BarChart>
                    </Card.Body>
                  )}
                </Card>
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
    </div>
  );
}

export default MedicalReviewerDashboard;
